if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        if (this.thumbsSwiper) {
          this.thumbsSwiper.destroy(true, true);
          this.thumbsSwiper = null;
        }

        if (this.swiper) {
          this.swiper.destroy(true, true);
          this.swiper = null;
        }

        const sliderEl = this.querySelector('.product__media-slider');
        if (!sliderEl) return;

        const thumbsEl = this.querySelector('.product__media-thumbs-slider');
        if (thumbsEl) {
          this.thumbsSwiper = new Swiper(thumbsEl, {
            spaceBetween: 8,
            slidesPerView: 'auto',
            watchSlidesProgress: true,
            slideToClickedSlide: false,
          });

          this.thumbsSwiper.on('click', () => {
            const clickedIndex = this.thumbsSwiper.clickedIndex;
            if (clickedIndex == null || Number.isNaN(clickedIndex)) return;
            this.swiperSlideTo(clickedIndex);
          });
        }

        const paginationEl = this.querySelector('.product__media-pagination');
        const slideCount = sliderEl.querySelectorAll('.swiper-slide:not(.hidden)').length;

        const options = {
          slidesPerView: 1,
          direction: 'horizontal',
          freeMode: false,
          longSwipes: false,
          loop: slideCount > 1,
          scrollbar: {
            el: this.querySelector('.swiper-scrollbar'),
            hide: false,
            draggable: true,
          },
        };

        if (paginationEl) {
          options.pagination = {
            el: paginationEl,
            clickable: true,
          };
        }

        const nextEl = this.querySelector('.product__media-thumbs-nav-btn--next');
        const prevEl = this.querySelector('.product__media-thumbs-nav-btn--prev');
        if (nextEl && prevEl) {
          options.navigation = {
            nextEl,
            prevEl,
          };
        }

        this.swiper = new Swiper(sliderEl, options);
        this._previousRealIndex = this.swiper.realIndex;

        if (this.thumbsSwiper) {
          this.syncThumbsActive(this.swiper.realIndex);
          this.swiper.on('slideChange', () => {
            const realIndex = this.swiper.realIndex;
            this.syncThumbsActive(realIndex);
            this.scrollThumbsOneByOne(realIndex);
            this._previousRealIndex = realIndex;
          });
        }
      }

      syncThumbsActive(index) {
        if (!this.thumbsSwiper) return;

        this.thumbsSwiper.slides.forEach((slide, i) => {
          slide.classList.toggle('swiper-slide-thumb-active', i === index);
        });
      }

      isThumbFullyVisible(index) {
        const thumbs = this.thumbsSwiper;
        const slideEl = thumbs?.slides?.[index];
        if (!slideEl) return true;

        const swiperRect = thumbs.el.getBoundingClientRect();
        const slideRect = slideEl.getBoundingClientRect();

        return slideRect.left >= swiperRect.left - 1 && slideRect.right <= swiperRect.right + 1;
      }

      scrollThumbsOneByOne(index) {
        const thumbs = this.thumbsSwiper;
        if (!thumbs) return;

        const previousIndex = this._previousRealIndex ?? index;
        if (this.isThumbFullyVisible(index)) return;

        const slideCount = thumbs.slides.length;
        const wrappedNext = previousIndex === slideCount - 1 && index === 0;
        const wrappedPrev = previousIndex === 0 && index === slideCount - 1;

        if (wrappedNext) {
          thumbs.slideTo(0);
          return;
        }

        if (wrappedPrev) {
          thumbs.slideTo(slideCount - 1);
          return;
        }

        // Adjacent nav: nudge the strip by a single thumbnail
        if (Math.abs(index - previousIndex) === 1) {
          if (index > previousIndex) {
            thumbs.slideNext();
          } else {
            thumbs.slidePrev();
          }
          return;
        }

        // Larger jumps (e.g. variant change): move directly to the active thumb
        thumbs.slideTo(index);
      }

      swiperUpdateSlides() {
        this.swiper?.updateSlides();
        this.thumbsSwiper?.updateSlides();
      }

      swiperUpdate() {
        this.swiper?.update();
        this.thumbsSwiper?.update();
      }

      swiperSlideTo(index) {
        if (!this.swiper) return;

        if (this.swiper.params.loop) {
          this.swiper.slideToLoop(index);
        } else {
          this.swiper.slideTo(index);
        }
      }
    }
  );
}
